import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

export default class balanceTransactionView extends JetView {
    // Defining balanceTransactionView class extending JetView
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const cur_user = this.getParam('user', true); // Getting current user parameter

        return {
            rows: [
                {
                    cols: [
                        {
                            view: 'datatable', // DataTable component
                            id: 'datatable', // Unique identifier for the DataTable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling
                            height: screen.width < 820 ? 405 : 0, // Conditional height based on screen width
                            columns: [
                                // Column definitions for the DataTable
                                {
                                    id: 'Date',
                                    header: _('Fecha'), // Localized header
                                    width: 150,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'TypeQuota',
                                    header: _('Tipo Cupo'), // Localized header
                                    editor: 'combo', // Combo editor for this column
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Apuestas') },
                                        { id: 'R', value: _('Recargas') },
                                    ],
                                    width: 100,
                                    sort: 'int',
                                },
                                {
                                    id: 'TypeTransaction',
                                    header: _('Tipo Transacción'), // Localized header
                                    editor: 'combo', // Combo editor for this column
                                    options: [
                                        // Options for the combo editor
                                        { id: 'E', value: _('Deposito') },
                                        { id: 'S', value: _('Salida') },
                                    ],
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'Amount',
                                    header: _('Valor'), // Localized header
                                    format: webix.i18n.priceFormat, // Formatting for price
                                    exportType: 'number', // Export type for this column
                                    width: 100,
                                    sort: 'int',
                                },
                            ],
                            on: {
                                // Event handlers for the DataTable
                                onBeforeLoad: function () {
                                    // Before loading data
                                    this.showOverlay(
                                        // Show loading overlay
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    );
                                },
                                onAfterLoad: function () {
                                    // After data is loaded
                                    this.hideOverlay(); // Hide loading overlay
                                },
                            },
                            ready: function () {
                                // When the DataTable is ready
                                if (!this.count()) {
                                    // Check if there are no rows
                                    webix.extend(this, webix.OverlayBox); // Extend with OverlayBox
                                    this.showOverlay(
                                        // Show no data overlay
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    );
                                }
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead setting
                            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
                            pager: 'pagerA', // Pager ID for pagination
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The DataTable instance.
     */
    init(grid) {
        grid = $$('datatable'); // Get the DataTable instance
        const cur_user = this.getParam('user', true); // Get current user parameter
        var url = devConfig.geturlApi() + 'null/Report/GetBalanceTransactionReport?FromId=' + cur_user + '&'; // Base URL for API requests
        var filter = ''; // Initialize filter string

        this.on(this.app, 'transfers:filter', (filterData) => {
            // Event listener for filter updates
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string

            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object values
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                        } else {
                            if (object[i][0] == 'Date') {
                                // Handle single date
                                var date = object[i][1].replace(' 00:00:00', '');
                                string1 = string1 + '&dateFrom=' + date;
                                string1 = string1 + '&dateTo=' + date;
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object values
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through nested object entries
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&FromId=' + cur_user; // Append current user to query string
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load data with filters
            filter = string1; // Update filter variable
        });

        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event for after sorting
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        grid.attachEvent('onDataRequest', function (start, count) {
            // Event for data requests
            custom_load(this.data.url, start, count); // Custom load function
            return true; // Indicate successful request
        });

        /**
         * Custom load function to fetch data.
         * @param {string} url - The URL to fetch data from.
         * @param {number} start - The starting index for data.
         * @param {number} count - The number of records to fetch.
         */
        function custom_load(url, start, count) {
            grid.load(url + '?start=' + start + '&count=' + count); // Load data with pagination
        }

        this.on(this.app, 'player:select', (id) => {
            // Event listener for player selection
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + id, // Load data for selected player
            );
        });
    }
}

// FILE DOCUMENTED
